/**
 * Backend Service Configuration
 */

export const SERVICE_URL = process.env.NEXT_PUBLIC_SERVICE_URL || "https://evm-api.pulsar.money";

export const SERVICE_CONFIG = {
  baseURL: SERVICE_URL,
  timeout: 30000,
} as const;
